import React from 'react'
import Gc from '../components/Gc/Gc';
import Helmet from '../components/Helmet/Helmet';

import gallery1 from '../assets/images/WhatsApp-Image-2024-02-06-at-14.45.10_879d6511.jpg'
import gallery2 from '../assets/images/WhatsApp-Image-2024-02-06-at-14.45.13_268aaacc.jpg'
import gallery3 from '../assets/images/WhatsApp-Image-2024-02-06-at-14.45.12_03a87ed5.jpg'
import gallery4 from '../assets/images/WhatsApp-Image-2024-02-06-at-14.45.10_0280a782.jpg'
import gallery5 from '../assets/images/WhatsApp-Image-2024-02-06-at-14.45.09_4b27cf32.jpg'
import gallery6 from '../assets/images/WhatsApp-Image-2024-02-06-at-14.45.12_7775ce33.jpg'
import gallery7 from '../assets/images/WhatsApp-Image-2024-02-06-at-14.45.10_26939151.jpg'
import gallery8 from '../assets/images/WhatsApp-Image-2024-02-06-at-14.45.13_67555f2c.jpg'

const Other = () => {

    const gallery = [
        { xs: 3, imgSrc: gallery1 },
        { xs: 3, imgSrc: gallery2 },
        { xs: 3, imgSrc: gallery3 },
        { xs: 3, imgSrc: gallery4 },
        { xs: 4, imgSrc: gallery5 },
        { xs: 4, imgSrc: gallery6 },
        { xs: 4, imgSrc: gallery7 },
        { xs: 12, imgSrc: gallery8 },
    ];

  return <Helmet title={'wildlife-photography-workshops-and-lectures'}>
  <section className='other__section __black'>
    <div className="w-1">
        <h1 className='__h1' >Wildlife Photography Workshops And Lectures</h1>
        <span className='dash'></span>
    </div>
    <div className="w-1">
        <Gc style={{height:'85vh'}} items={gallery} />;
    </div>
    <div className="w-1">
        <h2 className='__h2 __mb20'>Youtube Programs :​</h2>
        <div>
            <iframe width="100%" height="700" src="https://www.youtube.com/embed/-zt87tXsAfs?si=0gaSLkMGKfZUI30V" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>
        <div>
            <iframe width="100%" height="700" src="https://www.youtube.com/embed/rhjGw5ebIsE?si=_2wAD0jcckBU4ySv" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        </div>
        <div>

        </div>
    </div>
  </section>
  </Helmet>
}

export default Other